import { toast } from '@ethsign/ui';

import { doc2html } from '@/services/document';
import { IField, SIGN_MODE_ENUM } from '@/types';
import { IAddFields } from '@/types/template-type';
import { getHtmlBody } from '@/utils';
import { ControllerBase } from '@/utils/bizify';

interface IData {
  selectedItem?: IField;
  openSettingDrawer: boolean;
  html: string;
  initHtml?: string;
  [key: string]: any;
  fields?: IField[];
  signers?: any[];
  currentSigner: any;
  contractType?: SIGN_MODE_ENUM;
  loading?: boolean;
}
export class DataCtrl extends ControllerBase<IData> {
  protected $data(): IData {
    return {
      selectedItem: undefined,
      openSettingDrawer: false,
      html: '',
      initHtml: '',
      fields: [],
      signers: [],
      currentSigner: undefined,
      contractType: SIGN_MODE_ENUM.OneSignOne,
      loading: false
    };
  }
  setSelectItem = (item?: IField): void => {
    this.state.selectedItem = item;
    this.state.openSettingDrawer = item?.type !== 'signature' ? !!item : false;
  };
  setSettingDrawer = (open: boolean): void => {
    this.state.openSettingDrawer = open;
    if (!open) {
      this.state.selectedItem = undefined;
    }
  };
  initData = (data: IAddFields): void => {
    this.state.initHtml = data.html || '';
    this.state.html = data.html || '';
    this.state.fields = data.fields || [];
    this.state.signers = data.signers || [];
    this.state.contractType = data.contractType;
  };
  setData = (html: string, fields: IField[]): void => {
    const htmlBody = getHtmlBody(html);
    const isHtmlEmpty = !htmlBody || htmlBody === '<p>&nbsp;</p>';
    if (isHtmlEmpty) {
      this.state.initHtml = '';
    }
    this.state.html = html;

    this.state.fields = fields;
  };
  setFields = (fields: IField[]): void => {
    this.state.fields = fields;
  };
  setSigners = (signers: any[]): void => {
    this.state.signers = signers;
  };
  setCurrentSigner = (signer: { id: string; name: string }): void => {
    this.state.currentSigner = signer;
  };
  changeSigner = (
    type: 'add' | 'edit' | 'delete',
    signer: { id: string; name: string },
    editorRef: { current: any }
  ): void => {
    if (type === 'add') {
      this.state.signers!.push(signer);
    } else if (type === 'edit') {
      const index = this.state.signers!.findIndex((item: any) => item.id === signer.id);
      this.state.signers!.splice(index, 1, signer);
    } else {
      editorRef.current?.deleteElementsBySigner(signer.id);
      const index = this.state.signers!.findIndex((item: any) => item.id === signer.id);
      this.state.signers!.splice(index, 1);
    }
  };
  setContractType = (type: SIGN_MODE_ENUM): void => {
    this.state.contractType = type;
  };
  getHtml = async (file: File): Promise<void> => {
    this.state.loading = true;
    try {
      const res = await doc2html(file);

      this.state.initHtml = res;
    } catch (error) {
      toast({
        variant: 'error',
        title: 'Error',
        description: 'Conversion failed Please try again'
      });
    }
    this.state.loading = false;
  };
  setLoading = (loading: boolean): void => {
    this.state.loading = loading;
  };
}
